import { combineReducers } from '@reduxjs/toolkit';

// Slice import order is important to avoid uninitialised module issues.
import app from './app';
import appointment from './appointmentSlice';
import availability from './availabilitySlice';
import booking from './bookingSlice';
import calendar from './calendarSlice';
import consultation from './consultationSlice';
import consultationView from './consultationViewSlice';
import expert from './expertSlice';
import followUp from './followUpSlice';
import form from './formSlice';
import geolocation from './geolocationSlice';
import location from './locationSlice';
import patient from './patientSlice';
import prescription from './prescription';
import resource from './resourceSlice';
import rightPanel from './rightPanelSlice';
import sidePanel from './sidePanelSlice';
import slot from './slotSlice';
import smurTeam from './smurTeamSlice';
import supportDrawer from './supportDrawerSlice';
import table from './tableSlice';
import upload from './upload';
import user from './userSlice';
import workflows from './workflowSlice';
import { consultationCodesApi } from 'FRONTEND/utils/backendApi/consultationCodesApi';
import { consultationsApi } from 'FRONTEND/utils/backendApi/Consultations/consultationsApi';
import { drugReferencesApi } from 'FRONTEND/utils/backendApi/drugReferencesApi';

export default combineReducers({
  app,
  expert,
  patient,
  followUp,
  availability,
  appointment,
  user,
  slot,
  resource,
  location,
  booking,
  calendar,
  prescription,
  sidePanel,
  upload,
  supportDrawer,
  workflows,
  form,
  consultation,
  consultationView,
  smurTeam,
  geolocation,
  rightPanel,
  table,
  [consultationsApi.reducerPath]: consultationsApi.reducer,
  [consultationCodesApi.reducerPath]: consultationCodesApi.reducer,
  [drugReferencesApi.reducerPath]: drugReferencesApi.reducer,
});
